export default __webpack_public_path__ + "e1faf87cc1b7c06ca98e246a07c1ae46.png";